import DeleteIcon from '@mui/icons-material/Delete'
import { Box, CircularProgress, IconButton, Tooltip, Typography } from '@mui/material'

interface ModelListBulkActionsProps {
    selectedCount: number
    onBulkDelete: () => void
    isDeleting?: boolean
}

export const ModelListBulkActions: React.FC<ModelListBulkActionsProps> = ({
    selectedCount,
    onBulkDelete,
    isDeleting = false
}) => {
    if (selectedCount === 0) return null

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" color="text.secondary">
                {selectedCount} selected
            </Typography>

            <Tooltip title="Delete Selected">
                <IconButton onClick={onBulkDelete} color="error" disabled={isDeleting}>
                    {isDeleting ? <CircularProgress size={20} /> : <DeleteIcon />}
                </IconButton>
            </Tooltip>
        </Box>
    )
}
